import { FC, SVGProps } from 'react'

export const Reading: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M5.2284 7.15698C4.90086 6.90342 4.42979 6.96338 4.17623 7.29092C3.92266 7.61845 3.98263 8.08952 4.31016 8.34309L7.55991 10.8589C7.88745 11.1125 8.35852 11.0525 8.61208 10.725C8.86565 10.3975 8.80568 9.92638 8.47815 9.67281L5.2284 7.15698ZM2.20251 8.99327C1.87217 8.74338 1.40179 8.8086 1.1519 9.13894C0.90201 9.46929 0.967229 9.93966 1.29757 10.1896L8.86355 15.9129C8.99381 16.0115 9.15269 16.0648 9.31602 16.0648H21.5381C21.9523 16.0648 22.2881 15.729 22.2881 15.3148C22.2881 14.9006 21.9523 14.5648 21.5381 14.5648H9.56774L2.20251 8.99327Z"
			fill="currentColor"
		/>
	</svg>
)
